import { PayDistributionRuleType, PayDistributionType } from "types/BETypes";

import { FormType } from "./components/BankAccountsForm/validationSchema";

export const companyDefaultBankAccountBenefitsNumber = 5;
export const getCompanyDefaultBankAccountBenefitsList = (translationPrefix: string) => {
  const icons = [`✅`, `✅`, `✅`, `✅`, `✅`];
  const list = Array.from({ length: companyDefaultBankAccountBenefitsNumber }, (value, index) => {
    return {
      index: index + 1,
      icon: icons[index],
      text: `${translationPrefix}.${index}`,
    };
  });

  return list;
};

export const getCompanyDefaultBankAccountTemplate = (partnerAccountId?: string): FormType => {
  return {
    isEarlyPayEnabled: true,
    payDistributionRules: [
      {
        id: partnerAccountId || PayDistributionType.PARTNER_ACCOUNT,
        type: PayDistributionType.PARTNER_ACCOUNT,
        ruleType: PayDistributionRuleType.REMAINDER,
      },
    ],
  };
};
